import axios from "axios";
import {
  GET_USERDETAILS_BY_USERID,
  GET_STUDENT_STATUS_BY_USERID,
  GET_COUNSELLING_STUDENT_BY_ID,
  GET_STUDENT_FEESTRANSACTION
} from "./types";
import _ from "lodash";
const keys = require("../config/keys");

export const getUserDetailsByUserId = UserId => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetUserDetailsByUserId?UserId=" +
      UserId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({ type: GET_USERDETAILS_BY_USERID, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getStudentStatusDetailsByUserId = StudentId => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetApplicationStatusByStudentId?StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        var tempData = [];
        var fromDataList = _.uniqBy(res.data.data, "AdmFormGroupId");
        fromDataList.map(course => {
          var obj = { ...course };
          var a = res.data.data.filter(
            i => i.AdmFormGroupId === course.AdmFormGroupId
          );
          obj["CourseList"] = a;
          tempData.push(obj);
          return obj;
        });

        try {
          dispatch({
            type: GET_STUDENT_STATUS_BY_USERID,
            payload: tempData
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const payOnlinePayment = data => async dispatch => {
  // console.log("action = data;", data);
  await axios({
    method: "post",
    url: keys.ServicePath + "/payment/pay",
    data: data
  })
    .then(res => {
      if (res.data) {
        try {
          // console.log("action = rows[1];", res.data);
          if (res.data.gateway === "AXIS") window.location = res.data.params;
          else if (res.data.gateway === "PAYU BIZ")
            PayuRedirect(res.data.params, res.data.actionurl);
          else if (res.data.gateway === "ATOM")
            window.location = res.data.params;
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

const PayuRedirect = (objParams, actionurl) => {
  var form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("action", actionurl);
  Object.entries(objParams).forEach(([key, value]) => {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", value);
    form.appendChild(hiddenField);
  });
  document.body.appendChild(form);

  form.submit();
};

export const payTransaction = data => async dispatch => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/payment/payresponse",
    data: data
  })
    .then(res => {
      if (res.data) {
        try {
          //window.location = res.data;
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllCounsellingDetailByStudentId = (
  FormGroupId,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAllCounsellingDetailByStudentId?FormGroupId=" +
      FormGroupId +
      "&CourseId=" +
      0 +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_COUNSELLING_STUDENT_BY_ID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getStudentFeesDetailByFeesTransactionMstId = FeesTranMstId => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetStudentFeesDetailByFeesTransactionMstId?FeesTransactionMstId=" +
      FeesTranMstId
  })
    .then(res => {
      if (res.data.success) {
        var tempFeesData = [];
        var feesDataList = _.uniqBy(res.data.data, "StudentId");
        feesDataList.map(reciepts => {
          var obj = { ...reciepts };
          var a = res.data.data.filter(i => i.StudentId === reciepts.StudentId);
          obj["feesList"] = a;
          tempFeesData.push(obj);
          return obj;
        });
        try {
          dispatch({
            type: GET_STUDENT_FEESTRANSACTION,
            payload: tempFeesData
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getUserDetailsByUserId.js